export const DOT_FREQUENCY_OPTIONS = [
  { label: 'Täglich', value: 'DAILY' },
  { label: 'Wöchentlich', value: 'WEEKLY' },
  { label: 'Monatlich', value: 'MONTHLY' },
] as const;

export function toDotFrequencyPayload(value?: string) {
  if (!value?.trim()) return undefined;
  const preset = DOT_FREQUENCY_OPTIONS.find((option) => option.label === value.trim());
  return preset?.value ?? value.trim();
}

export function toDotFrequencyDisplayLabel(value?: string) {
  if (!value?.trim()) return '';
  const preset = DOT_FREQUENCY_OPTIONS.find((option) => option.value === value.trim());
  return preset?.label ?? value.trim();
}
